import type { Expression } from 'mapbox-gl';
import { VesselSource } from '../models/vessels/vessel.model';
import {
  type UserPreferences,
  VesselPrefColour,
  VesselPrefLabel,
  VesselPrefSize,
} from '../settings/user-preferences.slice';
import {
  GENERIC_VESSEL_SIZE,
  VESSEL_COLOUR_GREEN,
  VESSEL_COLOUR_NAVY,
  VESSEL_COLOUR_ORANGE,
  VESSEL_COLOUR_WHITE,
} from './vessel-constants.utils';

export const prepareVesselColourData = (preferences: UserPreferences) => {
  const defaultColour = VesselPrefColour.NAVY;
  const vesselColour =
    preferences?.vessel_preference?.vesselColour ?? defaultColour;

  const vesselColourMap = {
    [VesselPrefColour.ORANGE]: VESSEL_COLOUR_ORANGE,
    [VesselPrefColour.WHITE]: VESSEL_COLOUR_WHITE,
    [VesselPrefColour.NAVY]: VESSEL_COLOUR_NAVY,
  };

  const preferredColour = vesselColourMap[vesselColour] || VESSEL_COLOUR_NAVY;
  const iconColour: Expression = [
    'match',
    ['get', 'source'],
    VesselSource.AIS,
    preferredColour,
    VesselSource.RISK_INTELLIGENCE,
    VESSEL_COLOUR_GREEN,
    preferredColour,
  ];

  return iconColour;
};

const prepareVesselStylingData = (preferences: UserPreferences) => {
  const { vesselLabel, vesselSize } = preferences.vessel_preference;

  const label: Expression | string =
    vesselLabel === VesselPrefLabel.SHOW ? ['get', 'name'] : '';
  const sizeMultiplier = vesselSize === VesselPrefSize.LARGE ? 1.25 : 1;

  const size: Expression = [...GENERIC_VESSEL_SIZE];
  size[6] *= sizeMultiplier;
  size[8] *= sizeMultiplier;
  size[10] *= sizeMultiplier;

  const colour = prepareVesselColourData(preferences);

  return {
    label,
    size,
    colour,
  };
};

export const getUserVesselPreferenceColour = (preferences: UserPreferences) => {
  const defaultColour = VesselPrefColour.NAVY;
  const vesselColour =
    preferences?.vessel_preference?.vesselColour ?? defaultColour;

  const vesselColourMap = {
    [VesselPrefColour.ORANGE]: VESSEL_COLOUR_ORANGE,
    [VesselPrefColour.WHITE]: VESSEL_COLOUR_WHITE,
    [VesselPrefColour.NAVY]: VESSEL_COLOUR_NAVY,
  };

  const preferredVesselColour =
    vesselColourMap[vesselColour] || VESSEL_COLOUR_NAVY;

  return preferredVesselColour;
};

export default prepareVesselStylingData;
